// @flow
import type { Action } from "../actions/types";
import {
  FETCH_WALLET,
  FETCH_WALLET_SUCCESS,
  FETCH_WALLET_ERROR,
  SET_WALLET_AMOUNT,
  RESET_LOAD_WALLET,
  LOAD_WALLET,
  LOAD_WALLET_SUCCESS,
  LOAD_WALLET_ERROR,
  CAPTURE_WALLET_PAYMENT,
  FETCH_WALLET_REFUND_LIST,
  WALLET_REFUND_LIST_SUCCESS,
  WALLET_REFUND_LIST_ERROR,
  PROCESS_WALLET_REFUND,
  WALLET_REFUND_SUCCESS,
  WALLET_REFUND_ERROR,
  POOL_WALLET_LOAD,
  CANCEL_POOL_WALLET_LOAD,
  PARTIAL_REFUND,
  // RESET_WALLET_REFUND,
} from "../actions/types";

const initialState = {
  walletData: null,
  fetchedWallet: false,
  loadAmount: 0, // load money amount
  error: null,
  processingWalletLoad: false,
  processedWalletLoad: false,
  walletRefundData: null,
  isPooling: false,
	cancelPooling: false,
  partialRefund: false,
  partialRefundData: null,
};

export const walletReducer = (
  state: typeof initialState = initialState,
  { type, payload }: Action
): typeof initialState => {
  switch (type) {
    case FETCH_WALLET:
      return {
        ...state,
        walletData: null,
        fetchedWallet: false,
        error: null
      };

    case FETCH_WALLET_SUCCESS:
      return {
        ...state,
        walletData: payload,
        fetchedWallet: true,
        error: null
      };

    case FETCH_WALLET_ERROR:
      return {
        ...state,
        walletData: null,
        fetchedWallet: true,
        error: payload
      };

    case SET_WALLET_AMOUNT: 
      return {
        ...state,
        loadAmount: payload,
      }


    case LOAD_WALLET:
    case CAPTURE_WALLET_PAYMENT:
      return {
        ...state,
        error: null,
        processingWalletLoad: true,
        processedWalletLoad: false,
      };

    case LOAD_WALLET_SUCCESS:
      return {
        ...state,
        loadAmount: 0,
        error: null,
        processingWalletLoad: false,
        processedWalletLoad: true,
        isPooling: false,
        cancelPooling: false,
      };

    case LOAD_WALLET_ERROR:
      return {
        ...state,
        processingWalletLoad: false,
        processedWalletLoad: true,
        isPooling: false,
        cancelPooling: false,
        error: payload
      };

    case RESET_LOAD_WALLET: 
    return {
      ...state,  
      error: null,
      processingWalletLoad: false,
      processedWalletLoad: false,
      isPooling: false,
      cancelPooling: false,
    }

    case FETCH_WALLET_REFUND_LIST:
      return {
        ...state,
        fetchedWallet: false,
        walletRefundData: null,
        error: null,
        processingWalletLoad: false,
        processedWalletLoad: false,
        partialRefund: false,
        partialRefundData: null,
      };

    case WALLET_REFUND_LIST_SUCCESS:
      return {
        ...state,
        walletRefundData: payload,
        fetchedWallet: true,
        error: null
      };

    case WALLET_REFUND_LIST_ERROR:
      return {
        ...state,
        walletRefundData: null,
        fetchedWallet: true,
        error: payload
      };

    case PROCESS_WALLET_REFUND:
      return {
        ...state,
        error: null,
        processingWalletLoad: true,
        processedWalletLoad: false,
        partialRefund: false,
        partialRefundData: null,
      };

    case WALLET_REFUND_SUCCESS:
      return {
        ...state,
        loadAmount: 0,
        error: null,
        processingWalletLoad: false,
        processedWalletLoad: true,
        isPooling: false,
      };
    
    case PARTIAL_REFUND: 
      return {
        ...state,
        partialRefund: true,
        partialRefundData: payload,
        loadAmount: 0,
        error: null,
        processingWalletLoad: false,
        processedWalletLoad: true,
        isPooling: false,
      };

    case WALLET_REFUND_ERROR:
      return {
        ...state,
        processingWalletLoad: false,
        processedWalletLoad: true,
        isPooling: false,
        error: payload,
      };

    case POOL_WALLET_LOAD: 
			return {
				...state,
				isPooling: true,
			}

		case CANCEL_POOL_WALLET_LOAD: 
			return {
				...state,
				cancelPooling: true,
			}

    // case RESET_WALLET_REFUND:
    //   return {
    //   ...state,  
    //   error: null,
    //   processingWalletLoad: false,
    //   processedWalletLoad: false,
    // }

    default:
      return state;
  }
};